import { ReadinessMathTransferCtrl } from './readiness-math-transfer.controller';

export const ReadinessMathStepTransferComponent = {
  controller: ReadinessMathTransferCtrl,
  bindings: {
    prevStep: '&',
    nextStep: '&',
  },
  template: require('./readiness-math-transfer.html'),
};
